export const INLINE_INSPECTIONS = "inline-inspections";
export const PIPESCANNER_INSPECTIONS = "pipescanner-inspections";
